// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditHome/WaitingResult.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditHome/WaitingResult.tsx");
  import.meta.hot.lastModified = "1732036225889.6284";
}
// REMIX HMR END

import clsx from "clsx";
import IconResolver from "~/components/IconResolver";
import { resultMapping } from "../DocTahedroidImage";
import Heading from "~/components/Heading";
export default function WaitingResult() {
  const {
    speed: {
      title,
      message
    }
  } = resultMapping.waiting;
  return <hgroup className={clsx("md:col-span-9 md:row-start-1", "md:col-start-1")}>
      <Heading tag="h2" className="flex items-center">
        <IconResolver token="spinner" className="w-5 h-5 animate-spin mr-3" />{" "}
        {title}
      </Heading>
      <p className="text-neutral-600">{message}</p>
    </hgroup>;
}
_c = WaitingResult;
var _c;
$RefreshReg$(_c, "WaitingResult");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;